<template>
  <img class="logo" src="@/assets/images/logo.svg" alt="Marcos" />
</template>

<style lang="scss" scoped>
.logo {
  width: 100%;
}
</style>
